export function initBorlabsCookieA11yFixes() {
    let waitForBorlabs = () => {
        let cookieAccordionTargets = document.querySelectorAll('.BorlabsCookie [data-cookie-accordion-parent]'),
            options = {
                attributes: true,
            },
            observer;

        if (!cookieAccordionTargets.length) {
            setTimeout(() => {
                requestAnimationFrame(waitForBorlabs);
            }, 100);
            return;
        }

        observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'style') {
                    document
                        .querySelector(
                            '.BorlabsCookie [data-cookie-accordion-target="' +
                                mutation.target.dataset.cookieAccordionParent +
                                '"]',
                        )
                        .setAttribute('aria-expanded', mutation.target.style.display !== 'none');
                }
            });
        });

        cookieAccordionTargets.forEach((target) => {
            observer.observe(target, options);
        });

        // ensure that the focusable elements that are actually hidden are not able to gain focus by keyboard
        new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'aria-hidden') {
                    if (mutation.target.getAttribute('aria-hidden') !== 'false') {
                        mutation.target.querySelectorAll('.container, a, button, input').forEach((el) => {
                            el.tabIndex = -1;
                        });
                    } else {
                        mutation.target.querySelectorAll('.container, a, button, input').forEach((el) => {
                            el.tabIndex = '';
                        });
                    }
                }
            });
        }).observe(document.querySelector('.cookie-box'), options);
    };

    waitForBorlabs();
}
